export default __webpack_public_path__ + "assets/2ede9da85032040b0200150b94e6b996.jpg";